import React, { memo, useCallback } from "react";
import { useTranslation, Trans } from "react-i18next";
import styled from "styled-components";

import { Input, IconIdea, Alert, P1, Flexbox, helpers } from "@talentbait/shared-components";
import DraftCampaignStepLayout from "./DraftCampaignStepLayout";

const FakeLinkP1 = styled(P1)`
  span {
    line-break: anywhere;
    color: ${({ theme }) => theme.colors.primary.blue500};
  }
`;

const DraftCampaignStartStep = ({ state, onChange, errors, namespace, ...rest }) => {
  const { t } = useTranslation();

  const onJobPostingUrlChange = useCallback(
    (value, id) => {
      onChange(helpers.withHttp(value), id);
    },
    [onChange]
  );

  return (
    <DraftCampaignStepLayout
      header={t("Get started!")}
      subHeader={t("Please put in the job title and the website URL for the open position")}
      errors={errors}
      info={
        <Alert
          Icon={IconIdea}
          title={t("Targeted Job Page Selection")}
          message={t(
            "Based on your job title, we select the appropriate job page to ensure your campaign's success."
          )}
        />
      }
      namespace={namespace}
      {...rest}
    >
      <Input
        id="campaignName"
        label={t("Jobtitle")}
        placeholder={t("for example Marketing Manager")}
        value={state.campaignName}
        onChangeText={onChange}
        error={errors?.campaignName}
        log-namespace={namespace}
        tooltip={
          <Flexbox gap={16}>
            <P1>
              {t(
                "Put in the direct URL to the open position, not the general career page with all open positions."
              )}
            </P1>
            <Trans parent={FakeLinkP1}>
              For example: <span>www.carrerpage.com/marketing-manager/...</span>
            </Trans>
          </Flexbox>
        }
      />
      <Input
        id="jobPostingUrl"
        label={t("URL to open position")}
        placeholder={t("url placeholder", "https://example.com")}
        value={state.jobPostingUrl}
        onChangeText={onJobPostingUrlChange}
        error={errors?.jobPostingUrl}
        log-namespace={namespace}
      />
    </DraftCampaignStepLayout>
  );
};

export default memo(DraftCampaignStartStep);
